import { useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import { listFuels } from './Fuels.service';

export function useFuels(enabled = true) {
  const query = useQuery(
    ['fuels'],
    () => {
      return listFuels();
    },
    { enabled },
  );

  useServiceError(query.error);

  return query;
}
